export const Settings = {
  Settings: "Settings",
  Integrations: "Integrations",
  Security: "Security",
  Profile: "Profile",
  Emails: "Emails",
  Password: "Password and authentication",
  Sessions: "Sessions",
  GitHub: "GitHub",
  Datadog: "Datadog",
  Slack: "Slack",
  Jira: "Jira",
  "Account Settings": "Account Settings",
  Preferences: "Preferences",
  Account: "Account",
  DefaultReviewers: "Default reviewers",
  CustomReviewers: "Custom reviewers",
  Recommended: "Recommended",
  CustomPrinciplesExplained:
    "Custom Reviewers are derived based on code reviews performed by developers in your codebase. Select a Reviewer to view its prompt and the comments its based on."
}
